import { giftCardRouter } from "../gift-card/giftCardRouter"

import { Root } from "./Root"

export const rootRouter = [
  {
    path: "",
    element: (
      <Root />
    ),
    children: [
      ...giftCardRouter,
    ],
  },
]
